@if (replacedVehicle$ | async; as replacedVehicle) {
  <div class="pad-top-20 margin-bottom-20 row column twelve lg-push-two md-eight md-push-two">
    <amfam-review-quote
      [vehicleAdded]="newVehicle$ | async"
      [vehicleRemoved]="replacedVehicle"
      [discounts]="discounts$ | async"
      [policyCoverages]="policyCoverages$ | async"
      [vehicleCoverages]="vehicleCoverages$ | async"
      [vehiclesLeft]="remainingVehicles$ | async"
      [futurePayments]="futurePayments$ | async"
      [quotes]="quotes"
    >
    </amfam-review-quote>
    <blockquote class="border -primary-800 caption">
      <p
        dsContent
        [contentPath]="'policy.premiumBilling.replaceVehicle.disclaimer'"
        [options]="{ replaceVehicle: replacedVehicle.content }"
      ></p>
    </blockquote>
    <call-to-action
      [displayBackButton]="true"
      secondaryButtonName="Send to my agent"
      [primaryButtonName]="primaryButton$ | async"
      (primaryEvent)="handlePrimaryEventTrigger()"
      tertiaryButtonName="Cancel"
      (secondaryEvent)="sendToAgent()"
      (backEvent)="back()"
      (tertiaryEvent)="cancel()"
    ></call-to-action>
  </div>
}
<ds-exit-flow-modal
  [exitFlowModalId]="exitFlowModalId"
  [isPartner]="isPartner$ | async"
  (exit)="leave()"
  (cancelModal)="stay()"
  (notifyAgent)="sendToAgent(true)"
></ds-exit-flow-modal>
